import React from "react"

const SocialIconTwitter = ({
  className = "",
  width = "auto",
  height = "auto",
  fill,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m17 3.65886c-.6002.28523-1.2352.47314-1.885.55781.6829-.43736 1.1964-1.13219 1.4443-1.95416-.6456.41292-1.3508.70264-2.0853.85676-.3093-.35454-.6813-.63659-1.0934-.829-.412-.19242-.8556-.29117-1.3036-.29026-1.814 0-3.282 1.58228-3.282 3.5328-.00129.27131.02714.54181.08467.80572-1.30077-.06669-2.57449-.42963-3.73968-1.06558-1.16518-.63595-2.19616-1.53091-3.02699-2.62763-.29148.53743-.44562 1.15063-.44633 1.77551 0 1.225.58433 2.30781 1.46666 2.94218-.52275-.01357-1.0348-.1649-1.49266-.44114v.04375c0 1.71353 1.13333 3.13908 2.63333 3.46348-.28207.0823-.57274.124-.86467.124-.20714.0004-.41381-.0216-.617-.0656.417 1.4036 1.63067 2.4245 3.06834 2.4536-1.16821.9847-2.60246 1.517-4.07734 1.513-.26179-.0004-.52334-.0174-.78333-.051 1.50039 1.0479 3.24448 1.6022 5.02467 1.5969 6.04533 0 9.34803-5.3849 9.34803-10.05521 0-.15313-.0037-.30625-.0104-.45573.6411-.49873 1.1956-1.1185 1.6377-1.8302z"
        fill={fill}
      />
    </svg>
  )
}

export default SocialIconTwitter
